import * as withClientDetailsActions from '../actions/client-details';
import { ClientDetails } from '../models/client-details';
import { createSelector, createFeatureSelector } from '@ngrx/store';

export interface State {
  clients: ClientDetails[];
  clientDetails: ClientDetails;
  loading: boolean;
  error: string;
}

export const INITIAL_STATE: State = {
  clients: [],
  clientDetails: undefined,
  loading: false,
  error: ''
}

export function reducer(state: State = INITIAL_STATE, action: withClientDetailsActions.Actions) {
  var errorMessage: string;

  switch (action.type) {
  case withClientDetailsActions.GET:
    case withClientDetailsActions.LOAD:
      {
        return {
          ...state,
          error: '',
          loading: true
        };
      }
    case withClientDetailsActions.LOAD_COMPLETE:
      {
        return {
          ...state,
          error: '',
          loading: false,
          clients: action.payload
        };
      }
    case withClientDetailsActions.LOAD_ERROR:
      {
        errorMessage = '';
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }

        return {
          ...state,
          error: errorMessage,
          loading: false,
          clients: []
        };
      }
    case withClientDetailsActions.GET_COMPLETE:
    {
      return {
        ...state,
        error: '',
        loading: false,
        clientDetails: action.payload
      };
    }
    case withClientDetailsActions.GET_ERROR:
    {
      errorMessage = '';
      if (action.payload.hasOwnProperty('message')) {
        errorMessage = action.payload.message;
      }
      return {
        ...state,
        error: errorMessage,
        loading: false,
        clientDetails: undefined
      };

    }
    default:
      {
        return state;
      }
  }
}
